module.exports = __webpack_public_path__ + "img/cctvinspection_driving.5a42ef1f.svg";